<template>
  <div>
    <div
      class="header"
      ref="header"
      v-if="!inPremiumLounge"
      :style="{ paddingTop: `${headerPadding.top}px`, paddingBottom: `${headerPadding.bottom}px` }"
    >
      <button />
      <p>クーポン</p>
      <button @click="closeCouponModal">
        <img
          :src="require('@/assets/img/coupon-with-cart/coupon-close-icon.svg')"
          alt=""
        >
      </button>
    </div>
    <div class="list-wrapper" :style="{ paddingTop: `${listWrapperPaddingTop}px` }">
      <transition name="expand">
        <div
          v-if="hasCloseExpireAtCoupon"
          class="close-expire-at-coupon-alert"
          :class="inPremiumLounge && 'in-premium-lounge'"
        >
          <img
            :src="require('@/assets/img/coupon-with-cart/close-expire-at-coupon-alert-icon.svg')"
            alt=""
          />
          有効期限間近の{{ selectedTab.label }}があります。
        </div>
      </transition>
      <div v-if="needsTab && !inPremiumLounge" class="tab-container">
        <button
          v-for="(tab, i) in tabs"
          :key="i"
          :class="tab.key === selectedTab.key && 'selected'"
          type="button"
          @click="updateSelectedTab(tab)"
        >
          {{ tab.label }}
        </button>
      </div>
      <div class="list-container" :class="inPremiumLounge && 'in-premium-lounge'">
        <template v-if="coupons.length > 0">
          <coupon-with-cart-sorter v-if="!inPremiumLounge" />
          <div>
            <div v-for="(coupon, i) in coupons" :key="i">
              <coupon-with-cart-card
                :coupon="coupon"
                :index="i"
                :display-from="screenTypeList"
                @show-modal="showModal(coupon)"
                @open-external-url="openExternalUrl"
                @show-needs-clear-coupon-dialog="showNeedsClearCouponDialog"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div class='empty-coupon'>
            <img
              :src="require('@/assets/img/nocoupon.svg')"
              alt=""
            />
            <p>現在、このカテゴリの<br />クーポンはありません</p>
          </div>
        </template>
      </div>
    </div>
    <coupon-with-cart-modal
      ref="modal"
      key="modal"
      :close-button-offset-y="closeButtonOffsetY"
      @open-external-url="openExternalUrl"
    />
    <coupon-with-cart-modal
      ref="usedModal"
      key="usedModal"
      :mode="modalModeUsed"
      :close-button-offset-y="closeButtonOffsetY"
      @open-external-url="openExternalUrl"
    />
    <coupon-with-cart-cart
      ref="cart"
      :cart-header-padding-bottom="cartHeaderPaddingBottom"
      @before-use-coupons="showModal"
      @start-use-coupons="closeModalToUseCoupons"
      @finish-use-coupons="reShowModalAfterUseCoupons"
      @open-external-url="openExternalUrl"
    />
    <coupon-with-cart-dialog
      key="needsClearCouponDialog"
      ref="needsClearCouponDialog"
      negative-button-label="閉じる"
      @negative="closeNeedsClearCouponDialog"
    />
    <coupon-with-cart-toast ref="toast" />
    <template v-if="hasError">
      <error-popup
        :title="error.title"
        :message="error.message"
        :label="'もう一度試す'"
        @submit="fetchCouponsOnList"
        @close="clearError"
      />
    </template>
    <coupon-with-cart-dialog
      key="weatherCouponExpiredDialog"
      ref="weatherCouponExpiredDialog"
      negative-button-label="閉じる"
      @negative="closeWeatherCouponExpiredDialof"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '@/utils/DateFormatter'
import CouponWithCartCard from '@/views/CouponWithCart/Card.vue'
import CouponWithCartSorter from '@/views/CouponWithCart/Sorter.vue'
import CouponWithCartModal, { MODAL_MODE } from '@/views/CouponWithCart/Modal.vue'
import CouponWithCartCart from '@/views/CouponWithCart/Cart.vue'
import CouponWithCartToast from '@/views/CouponWithCart/Toast.vue'
import CouponWithCartDialog from '@/views/CouponWithCart/Dialog.vue'
import { COUPON_SELECT_TYPE, COUPON_TAB_TYPE, SCREEN_TYPE } from '@/store/couponWithCart'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'

export default {
  name: 'CouponWithCartList',
  components: {
    CouponWithCartDialog,
    CouponWithCartToast,
    CouponWithCartCart,
    ErrorPopup,
    CouponWithCartModal,
    CouponWithCartSorter,
    CouponWithCartCard
  },
  props: {
    forPremiumLounge: { type: Boolean, default: false },
    headerPaddingTopForPremiumLounge: { type: Number, default: 0 }
  },
  data() {
    return {
      apiTypeCoupon: '3',
      modal: false,
      selectedCouponIndex: 0,
      selectedTabCoupon: COUPON_TAB_TYPE.coupon,
      error: {},
      screenTypeList: SCREEN_TYPE.list,
      headerPaddingTop: 10,
      listWrapperPaddingTop: 0,
      modalModeUsed: MODAL_MODE.used
    }
  },
  async created() {
    document.title = 'クーポン'
    if (!this.forPremiumLounge) {
      window.receivedTopPadding = (payload) => {
        const json = JSON.parse(payload)
        this.headerPaddingTop = parseInt(json.paddingTop)
      }
      this.actionRequestPaddingTop()
    }
    await this.init(this.targetTab)
  },
  mounted() {
    this.listWrapperPaddingTop = this.$refs.header.clientHeight
  },
  computed: {
    ...mapGetters({
      coupons: 'CouponWithCart/couponsForList',
      hasCloseExpireAtCoupon: 'CouponWithCart/hasCloseExpireAtCoupon',
      couponTabByExpire: 'CouponWithCart/couponTabByExpire',
      tabs: 'CouponWithCart/tabs',
      selectedTab: 'CouponWithCart/selectedTab',
      inPremiumLounge: 'CouponWithCart/inPremiumLounge',
      selectedType: 'CouponWithCart/selectedType',
      preferredCouponsDoesNotExist: 'CouponWithCart/preferredCouponsDoesNotExist',
      modalShowing: 'CouponWithCart/showModal'
    }),
    needsTab() {
      return Object.keys(this.tabs).length > 1
    },
    hasError() {
      return Object.keys(this.error).length > 1
    },
    targetTab() {
      let tab = null
      if (this.$route.query.tab === COUPON_TAB_TYPE.coupon.key) {
        tab = COUPON_TAB_TYPE.coupon
      } else if (this.$route.query.tab === COUPON_TAB_TYPE.freePass.key) {
        tab = COUPON_TAB_TYPE.freePass
      }
      return tab
    },
    forceSelectTabByExpire() {
      return this.$route.query.force && this.$route.query.force === '1'
    },
    launchByWeatherCoupon() {
      return this.$route.query.weather && this.$route.query.weather === '1'
    },
    closeButtonOffsetY() {
      return parseInt(!this.forPremiumLounge ? this.headerPaddingTop : this.headerPaddingTopForPremiumLounge)
    },
    headerPadding() {
      if (window.navigator.userAgent.indexOf('Android') >= 0) {
        return { top: 17, bottom: 17 }
      } else {
        return { top: this.headerPaddingTop, bottom: 10 }
      }
    },
    cartHeaderPaddingBottom() {
      const paddingBottom = this.headerPaddingTop - 38
      return paddingBottom > 0 ? paddingBottom : 0
    }
  },
  watch: {
    async $route() {
      await this.init(this.targetTab)
    },
    preferredCouponsDoesNotExist(notExist) {
      if (notExist) {
        this.$refs.toast.show({
          content: '該当のクーポンは<br />ありませんでした',
          isHtmlDisplay: true
        })
      }
    },
    headerPaddingTop() {
      this.$nextTick(() => {
        if (!this.inPremiumLounge) {
          this.listWrapperPaddingTop = this.$refs.header.clientHeight
        }
      })
    },
    modalShowing(show) {
      if (!show) {
        this.$refs.cart.hideCart()
      }
    }
  },
  methods: {
    // TODO: イベントトラッキング未実装
    ...mapActions('CouponWithCart', [
        'fetchCoupons',
        'setSelectedTab',
        'setInPremiumLounge'
      ]
    ),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', [
        'actionRequestToken',
        'actionRequestExternalLink',
        'actionRequestPaddingTop',
        'actionRequestCloseCouponModal'
    ]),
    async init(tab = null) {
      this.setInPremiumLounge(this.forPremiumLounge)
      await this.fetchCouponsOnList(true, tab)
    },
    updateSelectedTab(tab) {
      this.setSelectedTab(tab)
    },
    async fetchCouponsOnList(fromInit = false, tab = null) {
      const accTime = new DateFormatter().format(new Date())

      const fetchCoupons = async ({ token, accTime, userId }) => {
        this.actionToggleLoading(true)
        try {
          await this.fetchCoupons({ token, accTime, userId })
          this.$emit('update-tabs', this.tabs)

          if (fromInit) {
            if (this.launchByWeatherCoupon) {
              this.setSelectedTab(COUPON_TAB_TYPE.coupon)
              const weatherCouponIndex = this.coupons.findIndex((c) => {
                return c.data.purpose === '3'
              })
              if (weatherCouponIndex < 0) {
                const imgSrc = require('../../assets/img/coupon-with-cart/weather-coupon-expired.png')
                const content = `
                  <div style="margin-top: 20px; text-align: center; font-weight: bold; font-size: 16px">お天気クーポンは<br />「有効期限切れ」または<br />「使用済み」になりました</div>
                  <img src="${imgSrc}" alt="" style="width: 100%; margin: 15px auto 5px" />
                  <div style="text-align: center; font-size: 13px">お天気クーポンは<br />有効期限の短いクーポンです。<br />何卒ご了承ください。</div>
                `
                this.$refs.weatherCouponExpiredDialog.show({
                  content,
                  isHtmlDisplay: true
                })
              }
            } else if (this.forceSelectTabByExpire) {
              this.setSelectedTab(this.couponTabByExpire)
            } else if (tab) {
              this.setSelectedTab(tab === COUPON_TAB_TYPE.freePass && !this.needsTab ? COUPON_TAB_TYPE.coupon : tab)
            } else if (this.needsTab && !this.inPremiumLounge) {
              this.setSelectedTab(COUPON_TAB_TYPE.freePass)
            }
          }
        } catch (e) {
          this.error = e
        } finally {
          this.actionToggleLoading(false)
        }
      }

      window.receivedToken = async (payload) => {
        const json = JSON.parse(payload)
        await fetchCoupons({ token: json.app_token, accTime, userId: json.user_id })
      }
      this.actionRequestToken({ apiType: this.apiTypeCoupon, acc_time: accTime })
      // FIXME: for development
      // await fetchCoupons({ token: 'a', accTime, userId: '89a1636f6b85c0d7' })
    },
    showModal(coupon = null) {
      if (this.modalShowing) {
        return
      }
      this.$refs.modal.show(coupon)
    },
    clearError() {
      this.error = {}
    },
    openExternalUrl(url) {
      this.actionRequestExternalLink(url)
      // FIXME: for development
      // window.open(url, '_blank')
    },
    closeModalToUseCoupons() {
      this.$refs.modal.close()
    },
    async reShowModalAfterUseCoupons() {
      await this.fetchCouponsOnList()
      this.$refs.usedModal.show()
    },
    showNeedsClearCouponDialog() {
      const needsLabel = this.selectedType.key === COUPON_SELECT_TYPE.eatIn.key
      const selectedTypeString = needsLabel ? `${this.selectedType.label}で使う` : ''
      const imgSrc = require('../../assets/img/coupon-with-cart/needs-clear-coupon.png')
      const dialogContent = `
        <div style="padding: 50px 0 10px; text-align: center; color: #333333; font-size: 14px; font-weight: bold">
          <img src="${imgSrc}" alt="" style="width: 100%; margin-bottom: 30px" />
          このクーポンを使うには<br />
          現在選択している<br />
          ${selectedTypeString}クーポンを<br />
          解除してください
        </div>
      `
      this.$refs.needsClearCouponDialog.show({
        content: dialogContent,
        isHtmlDisplay: true
      })
    },
    closeNeedsClearCouponDialog() {
      this.$refs.needsClearCouponDialog.close()
    },
    closeCouponModal() {
      this.actionRequestCloseCouponModal()
    },
    closeWeatherCouponExpiredDialof() {
      this.$refs.weatherCouponExpiredDialog.close()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none!important;;
  web-kit-appearance: none!important;
  -webkit-tap-highlight-color:rgba(0,0,0,0);

  &:disabled, &.disabled {
    opacity: 0.4;
  }
}

::v-deep .fade-enter-active, ::v-deep .fade-leave-active {
  transition: opacity 0.2s;
}
::v-deep .fade-enter,
::v-deep .fade-faster-enter,
::v-deep .fade-leave-to,
::v-deep .fade-faster-leave-to {
  opacity: 0;
}

.expand-enter-active, .expand-leave-active {
  transition: margin-top 0.2s, opacity 0.2s;
}

.expand-enter, .expand-leave-to {
  margin-top: -52px;
  opacity: 0;
}

.header {
  position: fixed;
  top: 0;
  background: #ffffff;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 16px;
  font-weight: bold;
  color: #222222;
  z-index: 2;

  button {
    width: 44px;
  }
}

.list-wrapper {
  .close-expire-at-coupon-alert {
    background: #fde7e7;
    padding: 0 16px;
    height: 52px;
    color: #e03535;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-right: 6px;
    }
  }

  .tab-container {
    display: flex;
    height: 30px;
    border: 1px solid #66160E;
    background: #66160E;
    margin: 15px 15px 0;
    border-radius: 4px;
    justify-content: space-around;
    overflow: hidden;

    & > * + * {
      margin-left: 1px;
    }

    button {
      display: block;
      width: 100%;
      background: #ffffff;
      font-weight: bold;
      font-size: 12px;
      color: #5a2200;

      &.selected {
        background: #5a2200;
        color: #ffffff;
      }
    }
  }

  .list-container {
    position: relative;
    padding: 15px 15px 75px;
    text-align: left;

    &.in-premium-lounge {
      padding: 0 14px 36px;
      margin-top: 15px;
    }

    .empty-coupon {
      text-align: center;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      p {
        font-size: 16px;
        line-height: 1.38;
        text-align: center;
        color: #e8c365;
        margin-top: 1rem;
      }
    }
  }
}
</style>
